import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'bp_trip_summary';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SemTripSummaryPage')), {
  delay: 500
});